import { Outlet } from "react-router-dom";
import { QueryProvider } from "@/components/providers/query-provider";
import { Toaster } from "sonner";

export default function App() {
  return (
    <QueryProvider>
      <Outlet />
      <Toaster richColors position="top-right" />
    </QueryProvider>
  );
}
